import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import './Teen120.css';

import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Teen120() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "teen120";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
           gameName={"1 CARD 20-20"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container onecard20"> */}
      {/* <div className="casino-header">
            <span className="casino-name">
              1 CARD 20-20
              <a className="ms-1">
                <small>Rules</small>
              </a>
            </span>
            <span className="casino-rid d-none d-xl-inline-block">
              <small>
                Round ID: <span>146250430215312</span>
              </small>
            </span>
          </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
            <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item">
                <div className="nav-link active">Game</div>
              </li>
              <li className="nav-item">
                <div className="nav-link">Placed Bet (0)</div>
              </li>
            </ul>
            <div className="pe-2">
              <span className="casino-rid">
                Round ID: <span>146250430215312</span>
              </span>
            </div>
          </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/teen120/9b815e19-bd17-49b8-9cc4-0c4e8dcc62e9?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards" /> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail onecard20">
        <div className="casino-table">
          <div className="casino-table-full-box">
            <div className="onecard20oddbox onecard20player">
              <div className="casino-odds text-center">
                {" "}
                {getOddForEntity("Player", casinoData, true)}
              </div>
              {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
              <div
                className={`casino-odds-box back casino-odds-box-theme  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Player", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">Player</span>
              </div>
              {/* <div className="casino-nation-book text-center" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Player")}
              </div>
            </div>
            <div className="onecard20oddbox onecard20tie">
              <div className="casino-odds text-center">
                {getOddForEntity("Tie", casinoData, true)}
              </div>
              {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
              <div
                className={`casino-odds-box back casino-odds-box-theme  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Tie", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">Tie</span>
              </div>
              {/* <div className="casino-nation-book text-center" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Tie")}
              </div>
            </div>
            <div className="onecard20oddbox onecard20dealer">
              <div className="casino-odds text-center">
                {getOddForEntity("Dealer", casinoData, true)}
              </div>
              {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
              <div
                className={`casino-odds-box back casino-odds-box-theme  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Dealer", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">Dealer</span>
              </div>
              {/* <div className="casino-nation-book text-center" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Dealer")}
              </div>
            </div>
            <div className="onecard20oddbox onecard20pair">
              <div className="casino-odds text-center">
                {getOddForEntity("Pair", casinoData, true)}
              </div>
              {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
              <div
                className={`casino-odds-box back casino-odds-box-theme  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Pair", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">Pair</span>
              </div>
              {/* <div className="casino-nation-book text-center" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Pair")} 
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
                <span>Last Result</span>
                <span>
                  <a href="/casino-results/teen120">View All</a>
                </span>
              </div>
              <div className="casino-last-results">
                <span className="result result-b">D</span>
                <span className="result result-b">D</span>
                <span className="result result-b">D</span>
                <span className="result result-b">D</span>
                <span className="result result-a">P</span>
                <span className="result result-b">D</span>
                <span className="result result-a">P</span>
                <span className="result result-a">P</span>
                <span className="result result-b">D</span>
                <span className="result result-b">D</span>
              </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
